import { useEffect } from 'react';

export const useJsonLd = (id, data) => {
  const serialized = data ? JSON.stringify(data) : null;

  useEffect(() => {
    if (!id || !serialized) return undefined;

    const selector = `script[type="application/ld+json"][data-jsonld-id="${id}"]`;
    let el = document.head.querySelector(selector);
    if (!el) {
      el = document.createElement('script');
      el.setAttribute('type', 'application/ld+json');
      el.setAttribute('data-jsonld-id', id);
      document.head.appendChild(el);
    }
    el.textContent = serialized;

    return () => {
      const existing = document.head.querySelector(selector);
      if (existing && existing.parentNode) {
        existing.parentNode.removeChild(existing);
      }
    };
  }, [id, serialized]);
};

export default useJsonLd;
